var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwatchbook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434.625 167.75L344.5 77.375C332.125 64.875 312 64.875 299.5 77.25L299.375 77.375L224 152.875V424L434.625 212.875C447.125 200.375 447.125 180.25 434.625 167.75ZM480 320H373.125L186.625 506.5C184.625 508.625 182.125 510.125 180 512H480C497.625 512 512 497.625 512 480V352C512 334.375 497.625 320 480 320ZM192 32C192 14.375 177.625 0 160 0H32C14.375 0 0 14.375 0 32V416C0 469 43 512 96 512S192 469 192 416V32ZM96 440C82.75 440 72 429.25 72 416S82.75 392 96 392S120 402.75 120 416S109.25 440 96 440ZM128 256H64V192H128V256ZM128 128H64V64H128V128Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwatchbook);
export default __webpack_public_path__ + "static/media/swatchbook.fed6679424c508435fca92b76911fda0.svg";
export { ForwardRef as ReactComponent };